function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { Constants } from '@shared/utils/constants';
import { routes } from '@shared/routerHistory';
import { getUserFavouriteEntityServiceType, getUserFavouriteEntityAppType } from '@shared/utils/userFavouriteDedicatedUtils';
// general utils
export function isApplication(applicationType) {
    return applicationType === getUserFavouriteEntityAppType();
}
export function isConsultingService(applicationType) {
    return applicationType === getUserFavouriteEntityServiceType();
}
export function getFavouriteEntityState(favourites, applicationType) {
    return favourites.map((favourite)=>{
        return {
            entityGuid: favourite.id,
            applicationId: favourite.applicationId,
            planId: favourite.planId,
            applicationType: applicationType,
            item: favourite.item
        };
    });
}
// redux store related
// upsert, either add, or update, a favourite based on entityId
export function upsertsUserFavouriteEntityState(entityList, payload) {
    const newEntity = {
        entityGuid: payload.id,
        applicationId: payload.applicationId,
        planId: payload.planId,
        item: payload.item,
        applicationType: payload.applicationType
    };
    // find update first
    const shouldUpdate = entityList.some((entity, index)=>{
        const foundMatch = entity.entityGuid === payload.id;
        if (foundMatch) {
            entityList[`${index}`] = newEntity;
        }
        return foundMatch;
    });
    if (shouldUpdate) {
        return;
    }
    // if it's not an update, it's an add
    entityList.push(newEntity);
}
// delete a favourite based on entityId
export function deleteUserFavouriteEntityState(entityList, payload) {
    let indexToDelete = -1;
    entityList.some((entity, index)=>{
        const foundMatch = entity.entityGuid === payload.entityGuid;
        if (foundMatch) {
            indexToDelete = index;
        }
        return foundMatch;
    });
    const numberOfEntityToDelete = indexToDelete === -1 ? 0 : 1;
    entityList.splice(indexToDelete, numberOfEntityToDelete);
}
// component related utils
export function getAllUserFavouriteCount(userFavourite) {
    const userFavouriteCount = userFavourite.fetchDataStatus === Constants.UserFavourite.FetchDataStatus.Valid ? userFavourite.apps.length + userFavourite.services.length : 0;
    return userFavouriteCount;
}
export function getUserFavouriteAppCount(userFavourite) {
    const userFavouriteCount = userFavourite.fetchDataStatus === Constants.UserFavourite.FetchDataStatus.Valid ? userFavourite.apps.length : 0;
    return userFavouriteCount;
}
export function getUserFavouriteServiceCount(userFavourite) {
    const userFavouriteCount = userFavourite.fetchDataStatus === Constants.UserFavourite.FetchDataStatus.Valid ? userFavourite.services.length : 0;
    return userFavouriteCount;
}
export function getUserFavouriteDetailPageRedirectUrl(buildHref) {
    return buildHref(routes.userFavouriteDetail, null, {
        category: null,
        industry: null,
        product: null,
        search: null,
        serviceType: null
    });
}
export function getUserFavouriteEntity(userFavourite, entityId) {
    let userFavouriteEntity;
    const hasFoundEntity = userFavourite.apps.some((app)=>{
        const hasFound = app.applicationId === entityId;
        if (hasFound) {
            userFavouriteEntity = _object_spread({}, app);
        }
        return hasFound;
    });
    if (hasFoundEntity) {
        return userFavouriteEntity;
    }
    userFavourite.services.some((service)=>{
        const hasFound = service.applicationId === entityId;
        if (hasFound) {
            userFavouriteEntity = _object_spread({}, service);
        }
        return hasFound;
    });
    return userFavouriteEntity;
}
export function getUserFavouriteViewEntityList(userFavouriteEntityList) {
    if (!userFavouriteEntityList) {
        return [];
    }
    return userFavouriteEntityList.map((userFavouriteEntity)=>userFavouriteEntity.item);
}
